import { z } from "zod";

/**
 * Shared DTO **Tài khoản nhận tiền của quỹ (admin)** — `GET /v1/admin/funds/:id/bank-account`
 * (US-AE4.F7-0909-S01 · @UC9950). CHỈ ĐỌC.
 *
 * Nguồn duy nhất là `Group.bankAccount` (đọc qua `GroupBankService.getBankAccount` — nhóm của quỹ).
 *
 * 🔴 KHÔNG có đường cho số tài khoản THÔ: schema chỉ có `accountNumberMasked`, và regex chặn mọi chuỗi
 * không mang dạng che `****` + tối đa 4 ký tự cuối (đúng đầu ra của `maskAccountNumber`). Số thô lỡ lọt
 * vào ⇒ parse fail ngay ở biên, không tới màn hình.
 *
 * Redaction: `accountName` (tên chủ tài khoản — PII) theo `canViewPii`; vai khác ⇒ `null`.
 * `configured=false` ⇒ nhóm chưa khai tài khoản (mọi trường chữ `null`, `hasQr=false`).
 */
export const ADMIN_MASKED_ACCOUNT_NUMBER_PATTERN = /^\*{4}.{0,4}$/;

export const adminFundBankAccountSchema = z
  .object({
    configured: z.boolean(),
    bankName: z.string().nullable(),
    accountNumberMasked: z.string().regex(ADMIN_MASKED_ACCOUNT_NUMBER_PATTERN).nullable(),
    accountName: z.string().nullable(),
    hasQr: z.boolean(),
  })
  .strict();

export type AdminFundBankAccount = z.infer<typeof adminFundBankAccountSchema>;
